import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // cmsId: localStorage.getItem('cmsId') || '',
  companyId: localStorage.getItem('companyId') || '',
  channelId: localStorage.getItem('channelId') || '',
  channelName: localStorage.getItem('channelName') || '',
  cmsName: localStorage.getItem('cmsName') || '',
  playlistId: localStorage.getItem('playlistId') || '',
  playlistName: localStorage.getItem('playlistName') || '',
};

const generateIdsSlice = createSlice({
  name: 'generateId',
  initialState,
  reducers: {
    setChannelId: (state, action) => {
      state.channelId = action.payload;
      localStorage.setItem('channelId', action.payload);
    },

    setPlaylistId: (state, action) => {
      state.playlistId = action.payload;
      localStorage.setItem('playlistId', action.payload);
    },
    setPlaylistName: (state, action) => {
      state.playlistName = action.payload;
      localStorage.setItem('playlistName', action.payload);
    },
  },
});

export const { setChannelId, setPlaylistId, setPlaylistName } = generateIdsSlice.actions;
export default generateIdsSlice.reducer;
